import { render, staticRenderFns } from "./StarIcon16px.vue?vue&type=template&id=16058096&"
import script from "./StarIcon16px.vue?vue&type=script&lang=ts&"
export * from "./StarIcon16px.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports